import { useCallback } from "react";
import { api } from "../api/api";
import { useApi } from "../core/hooks/useApi";
import { broadcast, useChannel } from "../core/hooks/useChannel";
import { useData } from "../core/hooks/useData";
import { expectArray, first } from "../core/utils/array";
import { isObject } from "../core/utils/conversion";
import { form_def } from "../types";
import { Presenter, prepareFormDef } from "./Presenter";
import { PresenterMessages, PresenterState } from "./types";

export function InlinePresenter(props: {
	id: string,
	formID: string,

	sourceValuesFrom?: any,
	options?: any,
}) {

	// expect data context to surround this
	const data = useData();

	const def = useApi({
		request: () => api.form_def_get({
			ids: [props.formID],
			dependencies: true,
		}),
		prepareResult: (result: form_def[]) => {
			const def = first(expectArray(result));

			// get all the subforms arranged
			prepareFormDef(def.data, def.subForms);

			return def;
		}
	}, [props.formID]) as form_def;

	useChannel(props.id, useCallback((msg: any) => {
		if (msg.type === PresenterMessages.READY) {
			const presenter = msg.state;
			initValues(presenter);
		}

	}, []));

	function initValues(presenter: PresenterState) {
		const valsToSet: any[] = [];
		function scan(prefix: string, o: any) {
			for(let m in o) {
				const v = o[m];

				if (v === undefined) continue;

				if (Array.isArray(v)) {
					// first make sure there is allocation of array items
					const msg = {
						type: PresenterMessages.GET_REPEATING_CONTAINER,
						prop: prefix + m,
					} as any;

					broadcast(presenter.channelID, msg);
					if (msg.items) {
						const items = msg.items;
						for(let i=0;i<v.length;i++) {
							items.push(v[i]);
						}
						msg.refresh();
					}

					// setTimeout(() => {
						// for(let i=0;i<v.length;i++) {
						// 	const a = v[i];
						// 	scan(prefix + m + "[" + i + "].", a);
						// 	//presenter.setFirstValue(prefix + m + "[" + i + "]", a);
						// }	
					// }, 50);

				} else if (!isObject(v)) {
					valsToSet.push({ prop: prefix + m, value: v });

				} else {
					scan(prefix + m + ".", v);
				}
			}
		}

		if (props.sourceValuesFrom) {
			scan("", props.sourceValuesFrom);

			// NOTE: have to set values this way to account for visibility changes which require re-renders etc
			if (valsToSet.length > 0) {
				let i = 0;

				const h = setInterval(() => {
					const item = valsToSet[i];
					presenter.setFirstValue(item.prop, item.value);
					
					i++;
					if (i >= valsToSet.length) clearInterval(h);
				}, 1);	
			}
		}
	}

	if (!def) return null;

	return (
		<div className="inline-presenter" style={{}}>
			<Presenter
				id={props.id}
				def={def.data}
				formValues={data.value}
				refs={def.refs}
				reports={def.reports!}
				options={props.options}

				showSaveCancel={false}
			/>
		</div>
	);
}